import { TLang } from 'src/constants/langs'

interface ITextBtn {
    lang: TLang
    text: string
}

export const textBtn: ITextBtn[] = [
    {
        lang: 'en',
        text: 'CONTINUE',
    },
    {
        lang: 'de',
        text: 'FORTFAHREN',
    },
    {
        lang: 'ro',
        text: 'Continuați',
    },
    {
        lang: 'es',
        text: 'CONTINUAR',
    },
    {
        lang: 'fr',
        text: 'CONTINUER',
    },
    {
        lang: 'it',
        text: 'CONTINUA',
    },
    {
        lang: 'pt',
        text: 'CONTINUAR',
    },
    {
        lang: 'el',
        text: 'ΣΥΝΕΧΙΣΤΕ',
    },
    {
        lang: 'sl',
        text: 'NADALJUJ',
    },
]
